module.exports = __webpack_public_path__ + "img/Macbook_Transparent_Scorecard_Row.40f12938.jpg";